import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { Col, Form, Row } from 'react-bootstrap';

import AuthLayout from '../../../layouts/AuthLayout/AuthLayout';
import { NioButton, NioField, NioToaster, NioBrand, NioCard } from '../../../components';
import { useTranslation } from '../../../i18n/I18nProvider';
import api from '../../../utils/api';

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [showSuccess, setShowSuccess] = useState(false);
  const [devLink, setDevLink] = useState('');
  const [submitError, setSubmitError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    mode: 'onBlur',
    defaultValues: { email: '' },
  });

  const onSubmit = async ({ email }) => {
    setSubmitting(true);
    setSubmitError('');
    setDevLink('');
    try {
      const response = await api.forgotPassword(email);
      if (!response?.success) {
        throw new Error(response?.message || t('auth.forgotError'));
      }
      if (response.devLink) setDevLink(response.devLink);
      setShowSuccess(true);
      reset();
      setTimeout(() => setShowSuccess(false), 6000);
    } catch (error) {
      setSubmitError(error.message || t('auth.forgotError'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout title={t('auth.forgotTitle')} rootClass="layout-1">
      {showSuccess && (
        <NioToaster
          variant="success"
          messages={[{ id: 1, header: t('auth.forgotTitle'), body: t('auth.resetSent') }]}
        />
      )}

      <NioCard className="nk-form-card card card-gutter-md nk-auth-form-card mx-md-9 mx-xl-auto">
        <NioCard.Body>
          <div className="nk-form-card-head text-center pb-5">
            <div className="form-logo mb-1 pb-1">
              <NioBrand logo="logo1" imageRoot="../images/" />
            </div>
            <h3 className="title mb-2">{t('auth.forgotHeading')}</h3>
            <p className="text">
              {t('auth.forgotSub')}{' '}
              <Link to="/auth/login" className="btn-link text-primary">{t('nav.login')}</Link>.
            </p>
          </div>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="gy-4">
              <Col xs={12}>
                <NioField label={t('auth.email')} htmlFor="email">
                  <NioField.Input
                    type="email"
                    id="email"
                    placeholder={t('auth.emailPlaceholder')}
                    errors={errors.email}
                    {...register('email', {
                      required: t('auth.emailRequired'),
                      pattern: {
                        value: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                        message: t('auth.emailInvalid'),
                      },
                    })}
                  />
                </NioField>
              </Col>
              {submitError && (
                <Col xs={12}>
                  <p className="text-danger small mb-0">{submitError}</p>
                </Col>
              )}
              {devLink && (
                <Col xs={12}>
                  <p className="text-muted small mb-0">
                    {t('auth.resetDevLink')}{' '}
                    <Link to={devLink.replace(/^https?:\/\/[^/]+/i, '')} className="btn-link text-primary">{devLink}</Link>
                  </p>
                </Col>
              )}
              <Col xs={12}>
                <div className="form-group">
                  <NioButton
                    type="submit"
                    className="btn-primary btn-block"
                    label={submitting ? t('auth.forgotSubmitting') : t('auth.sendReset')}
                    disabled={submitting}
                  />
                </div>
              </Col>
            </Row>
          </Form>
        </NioCard.Body>
      </NioCard>
    </AuthLayout>
  );
}
